import { Modal } from 'antd'

export interface UnsavedChangesModalOptions {
  onConfirm: () => void
  onCancel?: () => void
  title?: string
  content?: string
}

/**
 * Shows a standardized unsaved changes confirmation modal
 * @param options - Configuration options
 * @param options.onConfirm - Callback when user confirms leaving
 * @param options.onCancel - Callback when user cancels (optional)
 * @param options.title - Modal title (optional, defaults to 'Unsaved Changes')
 * @param options.content - Modal content (optional, defaults to standard message)
 */
export const showUnsavedChangesModal = ({
  onConfirm,
  onCancel,
  title = 'Unsaved Changes',
  content = 'You have unsaved changes. Are you sure you want to leave?'
}: UnsavedChangesModalOptions): void => {
  Modal.confirm({
    title,
    content,
    okText: 'Leave',
    okType: 'danger',
    cancelText: 'Stay',
    onOk: onConfirm,
    onCancel
  })
}
